import { getElement } from '../utils/dom-utils';

type FileHandler = (file: File) => void;

function isAcceptedFile(file: File): boolean {
  return file.name.endsWith('.csv') || file.name.endsWith('.json');
}

export function setupUploadZone(onFileSelected: FileHandler): void {
  const uploadZone = getElement('uploadZone');
  const fileInput = getElement<HTMLInputElement>('fileInput');

  if (!uploadZone || !fileInput) return;

  fileInput.addEventListener('change', (e) => {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (file && isAcceptedFile(file)) {
      onFileSelected(file);
    }
  });

  uploadZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadZone.classList.add('drag-over');
  });

  uploadZone.addEventListener('dragleave', (e) => {
    e.preventDefault();
    uploadZone.classList.remove('drag-over');
  });

  uploadZone.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadZone.classList.remove('drag-over');
    const file = e.dataTransfer?.files[0];
    if (file && isAcceptedFile(file)) {
      onFileSelected(file);
    }
  });
}

export function updateUploadZoneWithFileInfo(fileName: string, rowCount: number, onNewFile: FileHandler): void {
  const uploadZone = getElement('uploadZone');
  if (!uploadZone) return;

  uploadZone.classList.add('has-data');
  uploadZone.innerHTML = `
    <div class="file-info">
      <span>📄</span>
      <span>${fileName}</span>
      <span class="row-count">${rowCount} rows</span>
      <label class="file-input-label" style="margin-left: 16px; padding: 6px 12px; font-size: 0.85rem;">
        Load New File
        <input type="file" accept=".csv,.json" id="newFileInput">
      </label>
    </div>
  `;

  const newFileInput = getElement<HTMLInputElement>('newFileInput');
  if (newFileInput) {
    newFileInput.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file && isAcceptedFile(file)) {
        onNewFile(file);
      }
    });
  }
}
